<template>
  <div class="search_page">
    <div class="shp_1">
      <div>
        <input
          type="text"
          class="input"
          v-model="searchValue"
          :placeholder="siteNum0"
          @keyup.enter="search()"
        />
        <button type="button" @click="search()">{{ siteNum1 }}</button>
      </div>
    </div>
    <div class="shp_2">
      <moduleTitle :title="siteNum2"></moduleTitle>
      <gameBlock :gameBlocks="gameBlocks"></gameBlock>
    </div>
    <div class="shp_3">
      <moduleTitle :title="siteNum3"></moduleTitle>
      <brandDynamic :brandDynamics="brandDynamics"></brandDynamic>
    </div>
  </div>
</template>

<script>
import moduleTitle from "./component/moduleTitle";
import gameBlock from "./component/gameBlock";
import brandDynamic from "./component/brandDynamic.vue";
export default {
  name: "search_page",
  components: {
    moduleTitle,
    gameBlock,
    brandDynamic,
  },
  props: ["langType"],
  watch: {
    langType: function (type) {
      this.getText(type);
      this.searchData(this.content,type);
    },
  },
  mounted() {
    //获取传递的参数
    this.content = this.$route.params.content;
    //怕刷新网页，保存搜索内容
    if (this.content != undefined) {
      localStorage.setItem("content", this.content);
    } else {
      this.content = localStorage.getItem("content");
    }
    this.searchValue = this.content
    this.searchData(this.content,this.$i18n.locale);
    var lan = navigator.language;
    if(lan == 'zh-CN'){
      this.getText('zh')
    }else{
      this.getText('en')
    }
  },
  methods: {
    search() {
      this.searchData(this.searchValue)
      localStorage.setItem("content", this.searchValue);
    },
    searchData(content,language) {
      this.$post("/halababy/loofox/search", { content: content }).then((res) => {
        //处理游戏数据
        let games = new Array();
        for (let i = 0; i < res.data.game.length; i++) {
          let game = {
            id: res.data.game[i]["id"],
            name: res.data.game[i]["name"],
            description: res.data.game[i]["description"],
            icon: this.$ip + res.data.game[i]["icon"],
            image: this.$ip + res.data.game[i]["image"],
          };
          if(language == 'en'){
            game.name = res.data.game[i]["nameEn"];
            game.description = res.data.game[i]["descriptionEn"];
          }
          games.push(game);
        }
        this.gameBlocks = games;

        //处理品牌动态数据
        let brands = new Array();
        for (let i = 0; i < res.data.brand.length; i++) {
          let b = {
            id: res.data.brand[i]['id'],
            title: res.data.brand[i]['title'],
            image: this.$ip + res.data.brand[i]["image"],
            description: res.data.brand[i]['description'],
          }
          if(language == 'en'){
            b.title = res.data.brand[i]["titleEn"];
            b.description = res.data.brand[i]["descriptionEn"];
          }
          brands.push(b);
        }
        this.brandDynamics = brands;
      });
    },
    listenEnter() {
    },
    //获取文本
    getText(type) {
      this.$post("/halababy/loofox/text", { pageNum: 7 }).then((res) => {
        if (type == "zh") {
          this.siteNum0 = res.data[0]["content"];
          this.siteNum1 = res.data[1]["content"];
          this.siteNum2 = res.data[2]["content"];
          this.siteNum3 = res.data[3]["content"];
        } else {
          this.siteNum0 = res.data[0]["contentEn"];
          this.siteNum1 = res.data[1]["contentEn"];
          this.siteNum2 = res.data[2]["contentEn"];
          this.siteNum3 = res.data[3]["contentEn"];
        }
      });
    },
  },
  data() {
    return {
      title1: "应用软件",
      title2: "品牌动态",
      gameBlocks: this.gameBlocks,
      brandDynamics: this.brandDynamics,
      searchValue: this.content,
      siteNum0: this.siteNum0,
      siteNum1: this.siteNum1,
      siteNum2: this.siteNum2,
      siteNum3: this.siteNum3,
    };
  },
};
</script>

<style>
.search_page {
  width: 100%;
  background-color: white;
}
.shp_1 {
  width: 1200px;
  height: 140px;
  margin: auto;
  display: flex;
  align-items: center;
}
.shp_1 div {
  width: 1200px;
  height: 48px;
  background: #ffffff;
  border: 1px solid #e7e7ef;
  border-radius: 5px;
}
.shp_1 input {
  margin-left: 3%;
  width: 87%;
  height: 48px;
  border: none;
  padding: 0;
  float: left;
  outline: none;
  font-size: 20px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #696969;
  line-height: 30px;
}
.shp_1 button {
  width: 10%;
  height: 48px;
  float: left;
  background: #0ab1ff;
  border-radius: 5px;
  font-size: 20px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  border: none;
  cursor: pointer;
  padding: 0;
}
.shp_2 {
  width: 1200px;
  margin: auto;
}
.shp_3 {
  padding-top: 50px;
  width: 1200px;
  margin: 0 auto 50px auto;
}
</style>



// WEBPACK FOOTER //
// src/components/search.vue